import React, { useState } from 'react';
import {
    LOCATIONS,
    LOCATION_LIST,
    LOCATION_PRICE_LISTS,
    OVERTIME_NOTE,
    SLATINA_ID,
} from '../data/locations';

// Ценоразпис по локация. С подаден locationId показва списъка на този салон
// (страницата за резервации); без prop показва табове за двата салона (начална страница).
function BarberServices({ locationId }) {
    const [activeTab, setActiveTab] = useState(SLATINA_ID);
    const effectiveLocationId = locationId || activeTab;
    const services = LOCATION_PRICE_LISTS[effectiveLocationId] || [];
    const showTabs = !locationId;

    return (
        <section className="max-w-xl">
            <h2 className="text-center text-3xl py-4 text-red-800">Нашите Услуги</h2>

            {showTabs && (
                <div className="flex justify-center gap-3 pb-4">
                    {LOCATION_LIST.map((location) => (
                        <button
                            key={location.id}
                            type="button"
                            onClick={() => setActiveTab(location.id)}
                            className={`px-4 py-2 rounded-full text-lg whitespace-nowrap border border-red-800 transition duration-300 ${
                                activeTab === location.id
                                    ? 'bg-red-800 text-neutral-100 shadow'
                                    : 'bg-red-800 bg-opacity-10 text-red-800 hover:bg-opacity-30'
                            }`}
                        >
                            {location.shortName}
                            {location.isNew && (
                                <span className="ml-2 text-xs font-bold uppercase tracking-wider">ново</span>
                            )}
                        </button>
                    ))}
                </div>
            )}

            <p className="text-center text-neutral-700 pb-2">
                {LOCATIONS[effectiveLocationId]?.name} · {LOCATIONS[effectiveLocationId]?.address}
            </p>

            <ul className="max-w-6xl grid grid-cols-1 grid-rows-1 gap-2 text-center mx-auto">
                {services.map((service) => (
                    <li key={service.id} className="text-left">
                        {/* Ако името + цената не се събират на един ред (телефон), цената слиза на нов ред вдясно */}
                        <div className="flex flex-wrap items-end gap-x-2">
                            <h2 className="font-bold">{service.name}</h2>
                            <div className="h-px flex-1 min-w-[2rem] mb-1 bg-neutral-400"></div>
                            <p className="ml-auto text-right whitespace-nowrap">{service.priceLabel}</p>
                        </div>
                        <p>{service.description}</p>
                    </li>
                ))}
            </ul>

            <p className="text-center text-red-800 italic pt-4">{OVERTIME_NOTE}</p>
        </section>
    );
}

export default BarberServices;
